import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const fileTagsState = (state: RootState) => state.fileTags;

export const getFileTags = createSelector(fileTagsState, ({ fileTags }) => fileTags);
